import {
  Checkbox,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { IndianCurrency } from "app/utils/helper";
import dayjs from "dayjs";

const getStatusColor = (status) => {
  if (status === "Paid") return "success";
  if (status === "REJECTED" || status === "Not Paid") return "error";
  return "warning";
};

const HEADER_CELL_SX = { fontWeight: "bold", fontSize: "1rem" };

const TransactionTable = ({
  data,
  onCheckItem,
  onOrderDetailClick,
  onTransactionDetailClick,
}) => {
  if (!data?.length) return null;

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ mb: 2, borderRadius: 3 }}
    >
      <Table sx={{ minWidth: 850 }} size="medium">
        <TableHead sx={{ bgcolor: "grey.100" }}>
          <TableRow>
            <TableCell sx={HEADER_CELL_SX}>Product Description</TableCell>
            <TableCell sx={HEADER_CELL_SX}>Due Date</TableCell>
            <TableCell sx={HEADER_CELL_SX}>Amount</TableCell>
            <TableCell sx={HEADER_CELL_SX}>Discount</TableCell>
            <TableCell sx={HEADER_CELL_SX}>Paid</TableCell>
            <TableCell sx={HEADER_CELL_SX} align="center">To Be Paid</TableCell>
            <TableCell sx={HEADER_CELL_SX}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => {
            const toBePaid =
              Number(item?.netOrderAmount ?? 0) -
              Number(item?.paidAmount ?? 0) -
              Number(item?.totalExtraDiscount ?? 0);
            return (
              <TableRow key={i} hover>
                <TableCell>
                  <Typography
                    variant="body1"
                    color="primary"
                    sx={{
                      cursor: "pointer",
                      fontWeight: 500,
                      fontSize: "1.15rem",
                    }}
                    onClick={() => onOrderDetailClick(item)}
                  >
                    {item?.productDetail?.productDescription}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: "1.15rem" }}
                  >
                    {item?.productDetail?.productType} -{" "}
                    {item?.productDetail?.productName}
                  </Typography>
                </TableCell>
                <TableCell sx={{ fontSize: "1.15rem" }}>
                  {dayjs(item?.dueDate).format("DD MMM, YYYY")}
                </TableCell>
                <TableCell sx={{ fontSize: "1.15rem" }}>
                  {IndianCurrency(item?.orderAmount)}
                </TableCell>
                <TableCell sx={{ fontSize: "1.15rem" }}>
                  {IndianCurrency(
                    Number(item?.discountAtpurchage ?? 0) +
                      Number(item?.totalExtraDiscount ?? 0),
                  )}
                </TableCell>
                <TableCell>
                  <Typography
                    variant="body1"
                    color="primary"
                    sx={{
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: "1.15rem",
                    }}
                    onClick={() => onTransactionDetailClick(item)}
                  >
                    {IndianCurrency(Number(item?.paidAmount ?? 0))}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    {toBePaid !== 0 && !["Paid"].includes(item?.status) && (
                      <Checkbox
                        checked={!!item?.checked}
                        size="small"
                        onChange={() => onCheckItem(i)}
                      />
                    )}
                    <Typography
                      variant="body1"
                      fontWeight="600"
                      sx={{ fontSize: "1.15rem" }}
                    >
                      {IndianCurrency(toBePaid)}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Chip
                    label={item?.status}
                    color={getStatusColor(item?.status)}
                    size="medium"
                    variant="outlined"
                    sx={{ borderRadius: 2, fontWeight: 500 }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionTable;
